module.exports = __webpack_public_path__ + "img/home.7210ddcb.svg";